export function sendShowLog(group: string) {
    spy.sendCount({
        group,
        info: {
            show: 1
        }
    });
}

export function sendClickLog(group: string, act: string) {
    spy.sendCount({
        group,
        info: {
            click: 1
        },
        dim: {
            act
        }
    })
}
